import { SvgIcon } from '@mui/material';

export default function PlusIcon(props) {
  return (
    <SvgIcon width="24" height="25" viewBox="0 0 24 25" style={{fill: 'currentColor', stroke: 'none'}} {...props}>
      <path d="M11.5 19V13H5.5V12H11.5V6H12.5V12H18.5V13H12.5V19H11.5Z" />
    </SvgIcon>
  );
}
